import { hot } from "react-hot-loader/root";
import React from "react";
import { Panel } from "@sparkpost/matchbox";

const Section = ({ title, children, className = "" }) => {
  return (
    <Panel className={`tab-section ${className}`}>
      {title && <Panel.Header>{title}</Panel.Header>}
      <Panel.Section>{children}</Panel.Section>
    </Panel>
  );
};

export default hot(Section);
